import React, {useEffect, useState} from "react";
import {FC} from "react";

import {Breadcrumb, Button, Checkbox, Col, Form, Input, Result, Row, Upload} from "antd";
import {Trans} from "@lingui/macro";
import {InboxOutlined} from "@ant-design/icons";
import {useAxios} from "../../utils/hooks";
import type {RcFile, UploadFile, UploadProps} from "antd/es/upload/interface";
import {openNotification} from "../../utils/openNotification";



const LabelCheckerScreen : FC = () => {

    const axiosInstance = useAxios(process.env.REACT_APP_API_BASE_URL + "")

    const [form] = Form.useForm();


    const { Dragger } = Upload;

    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const [uploading, setUploading] = useState(false);
    const [hasfiles, setHasFiles] = useState(false);
    const [isValid, setIsValid] = useState<any>([]);
    const [isCheckFinished, setIsCheckFinished] = useState<Boolean>(false);
    const [isCheckLoading, setIsCheckLoading] = useState<boolean>(false);

    useEffect(() => {
            setHasFiles(fileList.length>0);
        },[fileList]

    );

    const uploadProps: UploadProps = {
        maxCount: 1,
        name: 'file',
        multiple: true,
        onChange(info) {
            const { status } = info.file;

            setIsCheckFinished(false);

            if(fileList.length > 1) {
                const index = fileList.indexOf(info.file);
                const newFileList = fileList.slice();
                newFileList.splice(index, 1);
                setFileList(newFileList);
            }

            if (status !== 'uploading') {
                //console.log(info.file, info.fileList);

            }
            if (status === 'done') {
                //message.success(`${info.file.name} file uploaded successfully.`);
            } else if (status === 'error') {
                //message.error(`${info.file.name} file upload failed.`);
            }
            // setFileList([...fileList, info.file]);
            setFileList(info.fileList);
        },
        onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);

        },
        beforeUpload: (file) => {

            if (fileList.length > 1) {
                return Upload.LIST_IGNORE;
            }
            // setFileList([...fileList, file]);

            return false;
        },
        onRemove: (file) => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);

        },
        fileList,
    };

    const handleUpload = () => {


        fileList.forEach((file) => {
            setIsValid(false);
            const uploadedFile = new FormData();
            uploadedFile.append('mFile', file.originFileObj as RcFile);
            if (axiosInstance.current != null) {

                setIsCheckLoading(true);
                axiosInstance.current.post("/resource/label-checker/is-valid",
                    uploadedFile,
                    { headers: { 'Content-Type': 'multipart/form-data' }
                }).then((response) => {
                    setIsValid(response.data);
                    console.log(response);
                    setUploading(false);
                }).catch(function (error :any) {
                    setIsValid(false);
                    openNotification('error',error);
                    console.log(error)
                    setUploading(false);
                }).finally(() => {
                    setIsCheckFinished(true);
                    setIsCheckLoading(false);
                });
            }
        });
        setUploading(true);
    };

    const handleFinish = () => {

        if (fileList.length == 1) {
            handleUpload();
        }
    }

    const handleFile = (file: File) => {
        if (file.type === "application/pdf") {
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL, "_blank");
        }
    };

    return (<>
            <Breadcrumb style={{ marginBottom: 10 }}>
                <Breadcrumb.Item><Trans id={'Homepage'}/></Breadcrumb.Item>
                <Breadcrumb.Item><Trans id={'Label Checker'}></Trans></Breadcrumb.Item>
            </Breadcrumb>

            {isValid == true && isCheckFinished == true
                ?
                <Result
                    status="success"
                    title={<Trans>Success Label Check!</Trans>}
                    subTitle={<Trans>Label document contains PRODUCTION DATE, so printing is enabled.</Trans>}
                    extra={[
                        <Button type="primary" key="print" onClick={() =>{

                            if (fileList.length > 0 && fileList[0].originFileObj) {
                                handleFile(fileList[0].originFileObj as File);
                            }
                        }}>
                            <Trans>Print</Trans>

                        </Button>,
                    ]}
                />
                :
                (fileList.length == 1 && isValid == false && isCheckFinished == true)
                    ?
                    <Result
                        status="error"
                        title={<Trans>Label Ducument Is Invalid</Trans>}
                        subTitle={<Trans>Printing is prohibited for this document.</Trans>}
                    />

                    : <></>
            }
            <Form id='upload-files'  form={form} layout="vertical" onFinish={() => handleFinish()}>
                {
                    <>
                        <Row gutter={24}>
                            <Col span={24}>
                                <Form.Item
                                    name="datafiles"
                                    children={<Dragger {...uploadProps} maxCount={1} multiple={false}>
                                        <p className="ant-upload-drag-icon">
                                            <InboxOutlined/>
                                        </p>
                                        <p className="ant-upload-text"><Trans>Click or drag file to this area to
                                            upload</Trans></p>
                                        <p className="ant-upload-hint">Csak egy fájl engedélyezett</p>
                                    </Dragger>
                                    }
                                />
                            </Col>
                        </Row>
                        <Form.Item
                            children={
                                <>
                                    <br/>
                                    <Button disabled={!hasfiles} loading={isCheckLoading} htmlType="button" type="primary" onClick={() => form.submit()}>
                                        <Trans>Check</Trans>
                                    </Button>
                                </>
                            }
                        />
                    </>
                }
            </Form>

        </>
    );
}
export default LabelCheckerScreen;
